<div *ngIf="!largeEnough" id="small-screen-warning">ブラウザのウィンドウサイズを大きくしてご利用ください。</div>
<div>
  <iframe #iframe id="interactive-tutorial" src="https://order-tutorial.brisk.jp" scrolling="no" frameborder="0"></iframe>
  <div>
    詳しくは<a href="https://static.brisk.jp/next-help/itaorderhelp.html" target="_blank" rel="noopener">板発注のヘルプ</a
    >をご参照ください。
  </div>
</div>
